<template>
  <div class="biz-score-picker-wrap-scope">
    <div class="instance">
      <el-slider :value="instanceValue"
                 :min="minScore"
                 :max="maxScore"
                 :marks="instanceMarks"
                 range
                 disabled></el-slider>
    </div>
    <div v-if="displayFraction"
         class="append">
      <div class="tip">支持小数</div>
    </div>
  </div>
</template>

<script>
import {hasClass} from 'element-ui/lib/utils/dom'
export default {
  name: 'BizScorePickerWrapScope',
  props: {
    displayFraction: Boolean,
    minScore: {
      type: Number,
      default: 0
    },
    maxScore: {
      type: Number,
      default: 100
    },
    passScore: {
      type: Number,
      default: 60
    }
  },
  computed: {
    instanceValue () {
      return [this.minScore, this.maxScore]
    },
    instanceMarks () {
      return {
        [this.minScore]: `最低分\n${this.minScore}`,
        [this.maxScore]: `最高分\n${this.maxScore}`,
        [this.passScore]: `及格线\n${this.passScore}`
      }
    }
  },
  methods: {
    onClickMark (event) {
      let target = event.target || event.srcElement
      if (target) {
        if (hasClass(target, 'el-slider__marks-text')) {
          const childNodes = target.parentNode.childNodes
          for (let index = 0; index < childNodes.length; index++) {
            if (childNodes.item(index) === target) {
              const score = Object.keys(this.instanceMarks)[index]
              if (!isNaN(score)) {
                this.$emit('click', `${score}`)
              }
              break
            }
          }
        }
      }
    },
    bindMarkEvent () {
      this.$el.addEventListener('click', this.onClickMark)
    },
    unbindMarkEvent () {
      this.$el.removeEventListener('click', this.onClickMark)
    }
  },
  mounted () {
    this.bindMarkEvent()
  },
  beforeDestroy () {
    this.unbindMarkEvent()
  }
}
</script>

<style lang="scss">
  .biz-score-picker-wrap-scope {
    text-align: center;
    & > .instance {
      padding: 4px 26px 26px;
      .el-slider {
        .el-slider__runway {
          height: 4px;
          .el-slider__bar {
            height: 4px;
          }
          .el-slider__button-wrapper {
            top: -16px;
            .el-slider__button {
              width: 10px;
              height: 10px;
            }
          }
        }
        .el-slider__stop {
          width: 4px;
          height: 4px;
          border-radius: 0;
        }
        .el-slider__marks {
          .el-slider__marks-text {
            margin-top: 10px;
            color: #606266;
            font-size: 12px;
            transform: translateX(-50%) scale(.85);
            white-space: pre;
            cursor: pointer;
          }
        }
      }
    }
    & > .append {
      padding: 4px 10px;
      background-color: #f0f2f5;
      & > .tip {
        color: #606266;
        transform: scale(.9);
      }
    }
  }
</style>
